import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  idUpload as bgvIdUploadAPI,
  educationCertificateUpload as educationCertificateUploadAPI,
  educationGradesheetUpload as educationGradesheetUploadAPI,
  saveBgvCache as saveBgvCacheAPI,
  setCertificateUpload as setCertificateUploadAPI,
  deleteGradesheetUpload as deleteGradesheetUploadAPI,
  setGradesheetUploadedUpdatedWithPassword as updateGradeSheetWithPasswordAction,
  setCertificateUploadUpdatedWithPassword as updateCertificateWithPasswordAction
} from '../../../../../../../actions/bgv';

const mapStateToProps = (state) => {
  return {
    uploadedCertificate: !isEmpty(state.certificateDetails)
      ? { ...state.certificateDetails }
      : null,
    uploadedGradesheet: state.gradesheetDetails && state.gradesheetDetails.length ? [...state.gradesheetDetails] : [],
    uploadedSingleGradesheet: state.singleGradeUpload,
    temporaryEducation: !isEmpty(state.temporaryEducation) ? { ...state.temporaryEducation } : {}
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    bgvIdUpload: (data) => dispatch(bgvIdUploadAPI(data)),
    educationCertificateUpload: (data) => dispatch(educationCertificateUploadAPI(data)),
    educationGradesheetUpload: (data) => dispatch(educationGradesheetUploadAPI(data)),
    updateGradeSheetWithPasswordAction: (data) =>
      dispatch(updateGradeSheetWithPasswordAction(data)),
    updateCertificateWithPasswordAction: (data) =>
      dispatch(updateCertificateWithPasswordAction(data)),
    setBgvCache: (data) => dispatch(saveBgvCacheAPI(data)),
    setCertificateUpload: (data) => dispatch(setCertificateUploadAPI(data)),
    deleteGradesheetUpload: (data) => dispatch(deleteGradesheetUploadAPI(data))
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps));
